import React from 'react';
export var TableContext = React.createContext({
  data: {
    stickyColumns: {}
  },
  update: function update() {}
});